import { SVGAttributes } from 'react';

type Props = {
  color: SVGAttributes<SVGPathElement>['fill'];
  className?: string;
  style?: React.CSSProperties;
};

export const Cursor = ({ color, className, style }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="57"
      viewBox="0 0 9 57"
      fill="none"
      className={className}
      style={style}
    >
      <path
        d="M3.00012 9.4314L3.00012 54.6237C3.00012 55.4604 3.67838 56.1387 4.51506 56.1387C5.35174 56.1387 6.03001 55.4604 6.03001 54.6237L6.03001 9.4767C6.03001 8.46994 6.40641 7.49955 7.08529 6.75611L7.38731 6.42538C9.63627 3.96257 7.88905 0.000938416 4.55389 0.000938416C1.27034 0.000938416 -0.496277 3.85703 1.64802 6.34373L2.00771 6.76086C2.64793 7.50331 3.00012 8.45105 3.00012 9.4314Z"
        fill={color}
      />
    </svg>
  );
};
